










































































































import { Component, Prop, Watch, Vue } from "@/shared/vuepack";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserBankAccountStore } from "@/shared/store/userBankAccount";
import { useCardProviderOptionsStore } from "@/employer/store/cardProviderOptions";
import { AuthenticationProvider, CardProvider, Permission, UserPermission } from "@/shared/types";
import AccountBalanceWidget from "@/shared/widgets/AccountBalanceWidget.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import ContributionsGraphWidget from "@/shared/components/contribution/ContributionsGraphWidget.vue";
import AccountHolderInvestment from "@/employer/components/partner-ee-service/AccountHolderInvestment.vue";
import AccountHolderBilling from "@/employer/components/partner-ee-service/AccountHolderBilling.vue";
import AccountHolderDependents from "@/employer/components/partner-ee-service/AccountHolderDependents.vue";
import AccountHolderBeneficiaries from "@/employer/components/partner-ee-service/AccountHolderBeneficiaries.vue";
import AccountHolderAuthorizedSigners
  from "@/employer/components/partner-ee-service/AccountHolderAuthorizedSigners.vue";
import AccountHolderCredentials from "@/employer/components/partner-ee-service/AccountHolderCredentials.vue";
import AccountHolderDetails from "@/shared/components/AccountHolderDetails.vue";
import AccountHolderUserSystemId from "@/employer/components/partner-ee-service/AccountHolderUserSystemId.vue";
import AccountHolderBankAccountHolds
  from "@/employer/components/partner-ee-service/AccountHolderBankAccountHolds.vue";
import AccountHolderNotes from "@/employer/components/partner-ee-service/AccountHolderNotes.vue";
import AccountHolderEmployer from "@/employer/components/partner-ee-service/AccountHolderEmployer.vue";
import AccountHolderDebitCards from "@/employer/components/partner-ee-service/AccountHolderDebitCards.vue";
import AccountHolderNotionalAccounts from "@/employer/components/partner-ee-service/AccountHolderNotionalAccounts.vue";
import AccountHolderExternalBankAccounts
  from "@/employer/components/partner-ee-service/AccountHolderExternalBankAccounts.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    AccountBalanceWidget,
    ContributionsGraphWidget,
    AccountHolderInvestment,
    AccountHolderBilling,
    AccountHolderDependents,
    AccountHolderBeneficiaries,
    AccountHolderAuthorizedSigners,
    AccountHolderCredentials,
    AccountHolderDetails,
    AccountHolderUserSystemId,
    AccountHolderBankAccountHolds,
    AccountHolderNotes,
    AccountHolderEmployer,
    AccountHolderDebitCards,
    AccountHolderNotionalAccounts,
    AccountHolderExternalBankAccounts,
    GenericLoadingSpinner
  }
})
export default class extends Vue {
  rolePermissionStore = useRolePermissionsStore();
  custodianSettingsStore = useCustodianSettingsStore();
  userBankAccountStore = useUserBankAccountStore();
  cardProviderOptionsStore = useCardProviderOptionsStore();
  drivewealthStore = useDrivewealthStore();

  @Prop ()
  username: string;

  @Prop ()
  partnerId: number;

  @Prop()
  routeToContributions: Location;

  canEditProfile = false;

  get isLoaded () {
    return this.custodianSettingsStore.isLoaded;
  }

  get missingPermissions () {
    return !this.hasAccountInfoReadPermision;
  }


  get hasAccountInfoReadPermision () {
    return this.rolePermissionStore.userHasPartnerPermission(Permission.HsaAccountInfoRead, this.partnerId);
  }

  get displayAccountHolderBilling () {
    return !this.custodianSettingsStore.isHsaBankCustodian && this.hasAccountInfoReadPermision;
  }

  get bankAccountHoldsVisible () {
    return this.custodianSettingsStore.displayBankAccountHolds;
  }

  get displayAuthorizedSigners () {
    return this.custodianSettingsStore.isHsaBankCustodian && this.hasHsaAccount;
  }

  get displayBeneficiaries () {
    return this.custodianSettingsStore.isHsaBankCustodian && this.hasHsaAccount;
  }

  get displayConsumerNotes () {
    return this.custodianSettingsStore.isHsaBankCustodian;
  }

  get displayEmploymentInfo () {
    return this.custodianSettingsStore.isHsaBankCustodian && this.hasHsaAccount;
  }
  get displayDebitCards () {
    return this.custodianSettingsStore.isHsaBankCustodian && this.isFiservCardholder;
  }
  get displayNotionalAccounts (): boolean {
    return this.custodianSettingsStore.isHsaBankCustodian;
  }
  get isFiservCardholder () {
    return this.cardProvider === CardProvider.Fiserv;
  }

  get cardProvider () {
    return this.cardProviderOptionsStore.cardProviderOptions
      ? this.cardProviderOptionsStore.cardProviderOptions.cardProvider
      : CardProvider.None;
  }

  get hasHsaAccount () {
    return this.userBankAccountStore.hsaAccountsLoaded &&
      this.userBankAccountStore.hsaAccounts.length > 0 &&
      this.userBankAccountStore.accountNumber !== null;
  }

  get hasInvestmentViewPermission (): boolean {
    return this.rolePermissionStore.doesUserHavePermission(
      UserPermission.PartnerPortalInvestmentView
    );
  }

  get hasManageUserLogin () {
    return this.rolePermissionStore.userHasPartnerPermission(Permission.PartnerManageUserLogin, this.partnerId);
  }

  get hasManageFraud () {
    return this.rolePermissionStore.userHasPartnerPermission(Permission.PartnerManageIdp, this.partnerId);
  }

  created () {
    const args = { username: this.username, partnerId: this.partnerId };
    this.userBankAccountStore.loadHsaAccounts(args);
    this.cardProviderOptionsStore.loadCardProviderOptions(args);
    this.drivewealthStore.loadAccountSummariesV2(args);

    this.custodianSettingsStore.getCustodianSettings(args);
  }

  handleCredentialsLoaded (profile: any) {
    if (profile) {
      this.canEditProfile = (profile.status === "staged" || profile.isCredentialed === false) &&
        profile.provider === AuthenticationProvider.Okta;
    }
  }
}
